// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import styled from "styled-components";

// const images = [
//   // "/assets/images/shop/shop-thumb-01.png",
//   "/assets/images/gallery/gallery 1.JPG",
//   "/assets/images/gallery/gallery 2.JPG",
//   "/assets/images/gallery/gallery 3.JPG",
//   "/assets/images/gallery/gallery 4.JPG",
//   "/assets/images/gallery/gallery 5.JPG",
//   "/assets/images/gallery/gallery 6.JPG",
//   "/assets/images/gallery/gallery 7.JPG",
//   "/assets/images/gallery/gallery 8.JPG",
//   "/assets/images/gallery/gallery 9.JPG",
//   "/assets/images/gallery/gallery 10.JPG",
//   "/assets/images/gallery/gallery 11.JPG",
//   "/assets/images/gallery/gallery 12.JPG",
// ];

// const Gallery = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const openModal = (index) => {
//     setCurrentIndex(index);
//     setIsOpen(true);
//   };

//   const closeModal = () => setIsOpen(false);

//   const nextSlide = () => {
//     setCurrentIndex((prev) => (prev + 1) % images.length);
//   };

//   const prevSlide = () => {
//     setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
//   };

//   return (
//     <Wrapper>
//       <section
//         className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
//         style={{
//           paddingTop: "45px",
//           paddingBottom: "45px",
//         }}
//       >
//         <div
//           className="rs-breadcrumb-bg"
//           style={{
//             backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
//           }}
//         ></div>
//         <div className="container">
//           <div className="row">
//             <div className="col-xxl-6 col-xl-8 col-lg-8">
//               <div className="rs-breadcrumb-content-wrapper">
//                 <div className="rs-breadcrumb-title-wrapper">
//                   <h1 className="rs-breadcrumb-title fs-1">Gallery</h1>
//                 </div>
//                 <div className="rs-breadcrumb-menu">
//                   <nav>
//                     <ul>
//                       <li>
//                         <span>
//                           <Link to="/">Home</Link>
//                         </span>
//                       </li>
//                       <li>
//                         <span>Gallery</span>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Gallery Section */}
//       <section className="rs-shop-area section-space">
//         <div className="container">
//           <div className="row g-4">
//             {images.map((img, index) => (
//               <div
//                 className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12"
//                 key={index}
//               >
//                 <div className="gallery-wrapper">
//                   <img src={img} alt="" className="gallery-img" />

//                   {/* Button */}
//                   <button
//                     className="gallery-btn popup-image"
//                     onClick={() => openModal(index)}
//                   >
//                     <i className="fas fa-plus" style={{ padding: "10px" }}></i>
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Lightbox */}
//       {isOpen && (
//         <div className="lightbox">
//           <span className="close" onClick={closeModal}>
//             &times;
//           </span>

//           <img src={images[currentIndex]} alt="" className="lightbox-img" />

//           <button className="prev" onClick={prevSlide}>
//             ❮
//           </button>

//           <button className="next" onClick={nextSlide}>
//             ❯
//           </button>
//         </div>
//       )}
//     </Wrapper>
//   );
// };

// const Wrapper = styled.section`
//   .gallery-wrapper {
//     position: relative;
//     overflow: hidden;
//     border-radius: 10px;
//   }

//   .gallery-img {
//     width: 100%;
//     height: 250px;
//     object-fit: cover;
//     transition: 0.3s;
//     border-radius: 10px;
//   }

//   /* Overlay */
//   .gallery-wrapper::after {
//     content: "";
//     position: absolute;
//     inset: 0;
//     background: rgba(0, 0, 0, 0.4);
//     opacity: 0;
//     transition: 0.3s;
//   }

//   /* Button */
//   .gallery-btn {
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translate(-50%, -50%) scale(0.8);
//     background: #ff6118;
//     border: none;
//     color: #fff;
//     font-size: 20px;
//     padding: 10px, 12px, 10px, 12px;
//     border-radius: 50%;
//     cursor: pointer;
//     opacity: 0;
//     transition: 0.3s;
//     z-index: 2;
//   }

//   /* Hover Effects */
//   .gallery-wrapper:hover::after {
//     opacity: 1;
//   }

//   .gallery-wrapper:hover .gallery-btn {
//     opacity: 1;
//     transform: translate(-50%, -50%) scale(1);
//   }

//   .gallery-wrapper:hover .gallery-img {
//     transform: scale(1.05);
//   }

//   /* Lightbox */
//   .lightbox {
//     position: fixed;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     background: rgba(0, 0, 0, 0.9);
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     z-index: 9999;
//   }

//   .lightbox-img {
//     max-width: 90%;
//     max-height: 90%;
//     border-radius: 10px;
//   }

//   .close {
//     position: absolute;
//     top: 20px;
//     right: 40px;
//     font-size: 40px;
//     color: #fff;
//     cursor: pointer;
//   }

//   .prev,
//   .next {
//     position: absolute;
//     top: 50%;
//     transform: translateY(-50%);
//     font-size: 40px;
//     color: #fff;
//     background: none;
//     border: none;
//     cursor: pointer;
//   }

//   .prev {
//     left: 30px;
//   }

//   .next {
//     right: 30px;
//   }
// `;

// export default Gallery;

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { FaPlay } from "react-icons/fa";

const images = [
  "/assets/images/gallery/gallery 1.JPG",
  "/assets/images/gallery/gallery 2.JPG",
  "/assets/images/gallery/gallery 3.JPG",
  "/assets/images/gallery/gallery 4.JPG",
  "/assets/images/gallery/gallery 5.JPG",
  "/assets/images/gallery/gallery 6.JPG",
  "/assets/images/gallery/gallery 7.JPG",
  "/assets/images/gallery/gallery 8.JPG",
  "/assets/images/gallery/gallery 9.JPG",
  "/assets/images/gallery/gallery 10.JPG",
  "/assets/images/gallery/gallery 11.JPG",
  "/assets/images/gallery/gallery 12.JPG",
];

const Gallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!isOpen) return;

      if (event.key === "Escape") {
        closeModal();
      }

      if (event.key === "ArrowRight") {
        nextSlide();
      }

      if (event.key === "ArrowLeft") {
        prevSlide();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);

  return (
    <Wrapper>
      <section
        className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
        style={{
          paddingTop: "45px",
          paddingBottom: "45px",
        }}
      >
        <div
          className="rs-breadcrumb-bg"
          style={{
            backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
          }}
        />

        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="rs-breadcrumb-content-wrapper">
                <div className="rs-breadcrumb-title-wrapper">
                  <h1 className="rs-breadcrumb-title fs-1">Gallery</h1>
                </div>

                <div className="rs-breadcrumb-menu">
                  <nav>
                    <ul>
                      <li>
                        <span>
                          <Link to="/">Home</Link>
                        </span>
                      </li>

                      <li>
                        <span>Gallery</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="rs-shop-area section-space gallery-section"
        style={{ paddingTop: "50px" }}
      >
        <div className="container">
          <span
            className="rs-section-subtitle has-theme-orange justify-content-center text-capitalize"
            style={{ marginBottom: "40px" }}
          >
            <FaPlay color="#EA5501" size={12} />
            Our Latest Image Gallery
          </span>

          <div className="row g-4">
            {images.map((img, index) => (
              <div
                className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12"
                key={img}
              >
                <div className="gallery-wrapper">
                  <img
                    src={img}
                    alt={`Gallery ${index + 1}`}
                    className="gallery-img"
                    loading="lazy"
                    decoding="async"
                    width="400"
                    height="250"
                  />

                  <button
                    type="button"
                    className="gallery-btn"
                    onClick={() => openModal(index)}
                    aria-label={`Open gallery image ${index + 1}`}
                  >
                    <i className="fas fa-plus" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {isOpen && (
        <div
          className="lightbox"
          onClick={(event) => {
            if (event.target === event.currentTarget) {
              closeModal();
            }
          }}
        >
          <button
            type="button"
            className="close"
            onClick={closeModal}
            aria-label="Close"
          >
            &times;
          </button>

          <button
            type="button"
            className="prev"
            onClick={prevSlide}
            aria-label="Previous image"
          >
            ❮
          </button>

          <img
            src={images[currentIndex]}
            alt={`Gallery ${currentIndex + 1}`}
            className="lightbox-img"
            decoding="async"
          />

          <button
            type="button"
            className="next"
            onClick={nextSlide}
            aria-label="Next image"
          >
            ❯
          </button>
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  /*
    IMPORTANT:
    Keep gallery items isolated from the rest of the page.
    The browser can skip rendering items that are far outside
    the current viewport.
  */

  .gallery-section {
    contain: layout paint;
  }

  .gallery-section .row > div {
    content-visibility: auto;
    contain-intrinsic-size: 250px;
  }

  .gallery-wrapper {
    position: relative;
    width: 100%;
    height: 250px;
    overflow: hidden;
    border-radius: 10px;
    background: #f5f5f5;
    contain: layout paint;
  }

  .gallery-img {
    display: block;
    width: 100%;
    height: 250px;
    object-fit: cover;
    border-radius: 10px;

    /*
      Do not animate the image.
      This makes scrolling much smoother.
    */
    transform: none;
    transition: none;

    /*
      Helps the browser optimize image rendering.
    */
    backface-visibility: hidden;
  }

  /*
    Overlay
  */
  .gallery-wrapper::after {
    content: "";
    position: absolute;
    inset: 0;

    background: rgba(0, 0, 0, 0.4);

    opacity: 0;
    visibility: hidden;

    pointer-events: none;

    border-radius: 10px;

    transition: opacity 0.2s ease;
  }

  /*
    Button
  */
  .gallery-btn {
    position: absolute;

    top: 50%;
    left: 50%;

    width: 48px;
    height: 48px;

    display: flex;
    align-items: center;
    justify-content: center;

    transform: translate(-50%, -50%);

    background: #ff6118;
    border: none;
    border-radius: 50%;

    color: #fff;
    font-size: 18px;

    cursor: pointer;

    opacity: 0;
    visibility: hidden;

    transition:
      opacity 0.2s ease,
      visibility 0.2s ease;

    z-index: 2;
  }

  /*
    Hover
  */
  .gallery-wrapper:hover::after {
    opacity: 1;
    visibility: visible;
  }

  .gallery-wrapper:hover .gallery-btn {
    opacity: 1;
    visibility: visible;
  }

  /*
    IMPORTANT:
    Removed transform: scale(1.05)
    because it causes additional repainting while
    moving around the page.
  */

  /*
    Lightbox
  */
  .lightbox {
    position: fixed;
    inset: 0;

    width: 100vw;
    height: 100vh;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 30px;

    background: rgba(0, 0, 0, 0.92);

    z-index: 99999;
  }

  .lightbox-img {
    display: block;

    max-width: 90vw;
    max-height: 90vh;

    width: auto;
    height: auto;

    object-fit: contain;

    border-radius: 10px;

    user-select: none;
  }

  /*
    Close
  */
  .close {
    position: absolute;

    top: 20px;
    right: 35px;

    width: 45px;
    height: 45px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: transparent;
    border: none;

    color: #fff;
    font-size: 42px;
    line-height: 1;

    cursor: pointer;

    z-index: 10;
  }

  /*
    Previous / Next
  */
  .prev,
  .next {
    position: absolute;

    top: 50%;

    width: 50px;
    height: 50px;

    display: flex;
    align-items: center;
    justify-content: center;

    transform: translateY(-50%);

    background: rgba(255, 255, 255, 0.15);

    border: none;
    border-radius: 50%;

    color: #fff;
    font-size: 28px;

    cursor: pointer;

    z-index: 10;
  }

  .prev {
    left: 25px;
  }

  .next {
    right: 25px;
  }

  .prev:hover,
  .next:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  /*
    Tablet
  */
  @media (max-width: 768px) {
    .gallery-wrapper {
      height: 220px;
    }

    .gallery-img {
      height: 220px;
    }

    .lightbox {
      padding: 20px;
    }

    .lightbox-img {
      max-width: 95vw;
      max-height: 85vh;
    }

    .prev,
    .next {
      width: 42px;
      height: 42px;
      font-size: 22px;
    }

    .prev {
      left: 10px;
    }

    .next {
      right: 10px;
    }

    .close {
      top: 10px;
      right: 15px;
      font-size: 36px;
    }
  }

  /*
    Mobile
  */
  @media (max-width: 576px) {
    .gallery-wrapper {
      height: 200px;
    }

    .gallery-img {
      height: 200px;
    }

    .gallery-btn {
      width: 44px;
      height: 44px;
    }

    .lightbox {
      padding: 15px;
    }

    .lightbox-img {
      max-width: 100%;
      max-height: 80vh;
    }
  }
`;

export default Gallery;
